import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "Please provide a link by forking these links or GitHub repo. ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "#repro-modal"
    }
  }, "What is a minimal reproduction, and why is it required?")));
});